// ============================================================
// LocationProvider 抽象 + factory
// ============================================================

import type { Fix, LatLon } from '../types'
import { DEFAULT_MOCK_LOCATION, MOCK_LOCATIONS } from '../config'
import { GeolocationProvider } from './geolocation-provider'
import { MockLocationProvider, type MockWalkConfig } from './mock-location-provider'

export interface LocationProvider {
  start(): Promise<void>
  stop(): void
  current(): Fix | null
  subscribe(handler: (fix: Fix) => void): () => void
}

export interface LocationProviderOptions {
  /** Mock 用: 初期位置 (デフォルト 東京駅) */
  start?: LatLon
  /** Mock 用: 仮想歩行設定 (なし or {bearing, speed_mps}) */
  walk?: MockWalkConfig | null
}

/**
 * 環境に応じて Provider を選ぶ。
 * - デフォルト: GeolocationProvider (navigator.geolocation)
 * - localStorage.setItem('geoMode', 'mock') で Mock に切替 (dev デバッグ用)
 *   さらに localStorage.setItem('devMock', 'tokyo|shinjuku|shibuya|ikebukuro|toshimaen') で地点指定
 */
export function createLocationProvider(opts: LocationProviderOptions = {}): LocationProvider {
  const forceMock =
    typeof localStorage !== 'undefined' && localStorage.getItem('geoMode') === 'mock'
  if (forceMock) {
    const key = (typeof localStorage !== 'undefined' && localStorage.getItem('devMock')) || ''
    const startLatLon =
      opts.start ??
      (key in MOCK_LOCATIONS ? MOCK_LOCATIONS[key] : DEFAULT_MOCK_LOCATION)
    return new MockLocationProvider({ start: startLatLon, walk: opts.walk ?? null })
  }
  return new GeolocationProvider()
}
